// Contextual messages for special floor tiles (checkpoints, save pads, upgrades).

import { G, rooms } from './state';
import { Get } from './mapgen';
import { CanGetArtifact } from './boss';

let firstGameHintTicks = 0;

function upgradePrice(t: number): number {
  switch (t) {
    case 0:
      return (100 - G.training * 50) * G.player_shield + (5 << G.player_shield) * (5 - G.training * 2);
    case 1:
      return (80 - G.training * 40) * G.circuit_fillrate + (5 << G.circuit_fillrate) * (4 - G.training * 2);
    case 2:
      return (80 - G.training * 40) * G.circuit_recoverrate + (5 << G.circuit_recoverrate) * (4 - G.training * 2);
    default:
      return 123;
  }
}

export function specialMessageText(m: number): string {
  switch (m) {
    case 1:
      return 'Ancient artifact: Complete Map';
    case 2:
      return 'Ancient artifact: Shield boost';
    case 3:
      return 'Ancient artifact: Extra crystal efficiency';
    case 4:
      return 'Ancient artifact: Circuit booster';
    case 5:
      return 'Ancient artifact: Metabolism increase';
    case 6:
      return 'Ancient artifact: Dodge enhancer';
    case 7:
      return 'Ancient artifact: Ethereal Monocle';
    case 8:
      return 'Ancient artifact: Crystal gatherer';
    case 10:
      return 'Enhancement: Shield upgrade';
    case 11:
      return 'Enhancement: Circuit charge upgrade';
    case 12:
      return 'Enhancement: Circuit refill upgrade';
    case 20:
      return 'Reward: Psi crystals';
    case 30:
      return "Holy Sword 'Balmung' answers your call";
    case 31:
      return "Mystic Halberd 'Amenonuhoko' answers your call";
    case 32:
      return "Divine Bow 'Gandiva' answers your call";
    case 33:
      return 'You capture the cursed seal. Return to the entrance';
    case 40:
      return 'Balmung will remain here, where the ley lines are strong';
    case 41:
      return 'Amenonuhoko will remain here, where the ley lines are strong';
    case 42:
      return 'Gandiva will remain here, where the ley lines are strong';
    case 50:
      return ". . . . . .   retrieved 'Agate Knife'";
    case 51:
      return 'Progress saved.';
    default:
      return 'ERROR: NO MESSAGE VALUE GIVEN';
  }
}

/** Floor-tile prompt only (no timed broadcast messages). */
export function resolveTilePrompt(tileX: number, tileY: number): string {
  const tile = Get(tileX, tileY);
  let message = '';

  switch (tile) {
    case 25:
      if (G.artifacts[11]) {
        message = "This is a checkpoint, but it doesn't seem to be working";
      } else if (G.checkpoints_found <= 1) {
        message = 'This is a checkpoint. You will return here when you die.';
      } else {
        message = 'Press ENTER to teleport between checkpoints.';
      }
      break;
    case 26:
      message = 'Press ENTER to open the storage chest';
      break;
    case 28:
      if (G.player_shield >= 25) message = 'Your shield is already at full efficiency';
      else message = `Press ENTER to upgrade shields (${upgradePrice(0)} crystals)`;
      break;
    case 29:
      if (G.circuit_fillrate >= 25) message = 'Your circuit charge rate is already at its highest';
      else message = `Press ENTER to upgrade circuit charge (${upgradePrice(1)} crystals)`;
      break;
    case 30:
      if (G.circuit_recoverrate >= 25) message = 'Your circuit refill rate is already at its highest';
      else message = `Press ENTER to upgrade circuit refill (${upgradePrice(2)} crystals)`;
      break;
    case 31:
      message = 'Press ENTER to record your progress';
      break;
    case 32:
      if (G.total_gems === 0) message = "This is a crystal device. It isn't working at the moment.";
      else message = 'Press ENTER to activate the crystal device';
      break;
    case 42:
      if (rooms[G.player_room].room_type === 5 && !CanGetArtifact()) {
        message = 'The artifact is tainted with shadow. You must slay more of the shadow first.';
      }
      break;
    default:
      if (G.first_game && firstGameHintTicks < 60) {
        message = 'Press H to read the help file';
        firstGameHintTicks++;
      }
      break;
  }

  return message;
}

export function showSpecialMessage(id: number, frames: number): void {
  G.specialmessage = id;
  G.specialmessagetimer = frames;
}

/** Advance timed broadcast message; call at most once per frame. */
export function consumeTimedSpecialMessage(): string {
  if (G.specialmessage === 0) return '';
  const message = specialMessageText(G.specialmessage);
  G.specialmessagetimer--;
  if (G.specialmessagetimer <= 0) G.specialmessage = 0;
  return message;
}

/** Tile id under the player. Timed broadcast messages take priority over tile prompts. */
export function resolveSpecialTilePrompt(tileX: number, tileY: number): { message: string; tile: number } {
  const tile = Get(tileX, tileY);
  let message = '';
  if (G.specialmessage !== 0) {
    message = consumeTimedSpecialMessage();
  } else {
    message = resolveTilePrompt(tileX, tileY);
  }
  return { message, tile };
}

export function resetFirstGameHint(): void {
  firstGameHintTicks = 0;
}
